import ResourceService from './resource.service'

class ReportService extends ResourceService {
  static get resource() {
    return 'report'
  }
}

export default ReportService
